export default {
  props: {
    baseUrl: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: false
    },
    value: {
      type: Object,
      default: undefined
    },
  },
  data: () => ({
    formModel: undefined,
    erroresValidacion: {},
    guardando: false,
  }),
  methods: {
    getSavePromise(formModel) {
      return this.id
        ? this.$http.put(
        this.updateUrl || `${process.env.VUE_APP_ROOT_API}${this.baseUrl}/${this.id}`,
        formModel,
        )
        : this.$http.post(
        this.createUrl || `${process.env.VUE_APP_ROOT_API}${this.baseUrl}`,
        formModel,
        ).then(r => r.json());
    },
    guardarForm () {
      let formModel = this.getFormModel();
      this.guardando = true;
      let savePromise = this.getSavePromise(formModel);
      savePromise
        .then(
          (id) => {
            if (this.snackbar){
              this.snackbar.color = 'success';
              this.snackbar.message = 'Guardado exitosamente';
              this.addSnack({message: this.snackbar.message, type: this.snackbar.color});
            }
            this.erroresValidacion = {};
            this.guardando = false;
            this.onFormSaved(id);
          },
          (error) => {
            if (process.env.VUE_APP_DEBUG === "true") {
              console.log(error);
            }
            if (this.snackbar) {
              this.snackbar.color = 'error';
            }
            if (error.status === 400) {
                this.erroresValidacion = error.body;
                if (this.snackbar) {
                  this.snackbar.message = 'Existen errores de validación';
                  this.addSnack({message: this.snackbar.message, type: this.snackbar.color});
                }
                this.guardando = false;
            } else if(error.status === 403) {
              if (this.snackbar) {
                this.snackbar.message = 'No tiene permisos para realizar esta acción';
                this.addSnack({message: this.snackbar.message, type: this.snackbar.color});
              }
              this.guardando = false;
            } else {
              if (this.snackbar) {
                this.snackbar.message = 'Ocurrió un error al intentar guardar';
                this.addSnack({message: this.snackbar.message, type: this.snackbar.color});
              }
              this.guardando = false;
            }
          }
        );
    },
    onFormSaved(resultObj) {
      this.$emit('saved', resultObj);
    },
    getFormModel () {
      return Object.assign({}, this.formModel);
    },
  },
  watch: {
    value() {
      this.formModel = this.value;
    },
    formModel: {
      deep: true,
      handler() {
        this.$emit('input', this.formModel);
      },
    },
    erroresValidacion: {
      deep: true,
      handler() {
        this.$emit('errorValidacion', this.erroresValidacion);
      },

    },
    computed: {
      createUrl() {
        return `${process.env.VUE_APP_ROOT_API}${this.baseUrl}`;
      },
      updateUrl() {
        return `${process.env.VUE_APP_ROOT_API}${this.baseUrl}/${this.id}`;
      }
    },
  },
}
